import { render, staticRenderFns } from "./Datepicker.vue?vue&type=template&id=1dedcdf6"
import script from "./Datepicker.vue?vue&type=script&lang=ts"
export * from "./Datepicker.vue?vue&type=script&lang=ts"
import style0 from "./Datepicker.vue?vue&type=style&index=0&id=1dedcdf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports